module.exports = __webpack_public_path__ + "assets/images/CHF200.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CHF200.png
// module id = 1340
// module chunks = 1